var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.002 3.6a6.402 6.402 0 100 12.805 6.402 6.402 0 000-12.805zM1.9 10.002a8.102 8.102 0 1116.204 0 8.102 8.102 0 01-16.204 0zm9.07 3.929a.907.907 0 11-1.814 0 .907.907 0 011.813 0zm-.968-8.807A2.663 2.663 0 007.34 7.787v.201h1.7v-.201a.963.963 0 011.926 0v.42c0 .438-.207.85-.56 1.11l-.334.249a2.27 2.27 0 00-.919 1.824v.627h1.7v-.627c0-.18.086-.35.231-.458l.334-.248a3.083 3.083 0 001.248-2.477v-.42a2.663 2.663 0 00-2.663-2.663z"
  })));
}
export default SvgQuestion;